enum LockerRoomModes {
  Create,
  Edit,
  AddStyle,
}

export default LockerRoomModes;
